<app-header />

@if (isLoading) {
  <div class="max-w-7xl mx-auto px-6 py-20 text-center">
    <p class="text-gray-600">Cargando localidad...</p>
  </div>
} @else if (error || !event || !tipoticket) {
  <div class="max-w-7xl mx-auto px-6 py-20 text-center">
    <h2 class="text-2xl font-bold text-gray-800 mb-4">No se pudo cargar</h2>
    <p class="text-gray-600 mb-6">La localidad que buscas no está disponible.</p>
    <button
      (click)="goBackToEvent()"
      class="bg-[#e8343f] text-white px-6 py-3 rounded-lg hover:bg-red-700 transition-colors"
    >
      Volver al evento
    </button>
  </div>
} @else {
  <section class="border-b border-gray-300">
    <div class="max-w-7xl mx-auto px-6 pt-2 pb-4">
      <div class="aspect-[40/21] bg-gray-100 border border-gray-300 overflow-hidden rounded-2xl relative">
        <img
          [src]="getBannerImage()"
          [alt]="event.nombre"
          class="w-full h-full object-cover"
        />
        <div class="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-8">
          <div>
            <nav class="flex items-center text-white/80 text-sm mb-3 flex-wrap gap-1">
              <button (click)="goBackToEvent()" class="hover:text-white transition-colors">{{ event.nombre }}</button>
              <svg class="w-4 h-4 mx-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
              <span class="text-white font-semibold">Comprar localidad</span>
            </nav>
            <h1 class="text-3xl md:text-4xl font-bold text-white">{{ tipoticket.nombre_localidad }}</h1>
            <p class="text-white/90 mt-1">{{ formatFechaHora(event.fecha_hora) }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="py-10">
    <div class="max-w-7xl mx-auto px-6">
      <div class="mb-6">
        <button
          (click)="goBackToEvent()"
          class="flex items-center text-gray-600 hover:text-[#e8343f] transition-colors"
        >
          <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
          </svg>
          Volver al evento
        </button>
      </div>

      @if (isExpired) {
        <div class="mb-6 bg-red-50 border-2 border-red-200 rounded-xl p-6">
          <div class="flex items-start gap-4">
            <div class="bg-red-100 rounded-full w-12 h-12 flex items-center justify-center shrink-0">
              <svg class="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>
            <div class="flex-1">
              <h3 class="text-lg font-bold text-red-900 mb-1">Venta web no disponible</h3>
              <p class="text-red-700">{{ expirationMessage }}</p>
            </div>
          </div>
        </div>
      }

      @if (!isExpired) {
        <app-ticket-selector-tren
          [eventoid]="event.eventoid"
          [url_slug]="event.url_slug"
          [event]="event"
          [directTipoTicketId]="tipoticketid"
          (ticketsAdded)="onTicketsAdded()"
        />
      }
    </div>
  </section>
}

<app-footer />
<app-scroll-to-top />
